import { __assign, __extends } from "tslib";
import { Icon } from '../icon/icon';
import { checkboxIconSvgData } from './checkbox-icon';
import { checkboxLargeIconSvgData } from './checkbox-large-icon';
import { namespacedClassnames } from '../../common/namespace-classes';
import * as React from 'react';
import { Tooltip } from '../tooltip/tooltip';
import { Text } from '../../new-libby/core/typography';
var defaultProps = {
    disabled: false
};
export var checkboxKey = 'checkbox';
var Checkbox = /** @class */ (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toggle = function (e) {
            return !_this.props.disabled ? _this.props.onChange(!_this.props.value, e) : null;
        };
        return _this;
    }
    Checkbox.prototype.render = function () {
        var _a;
        var props = __assign(__assign({}, defaultProps), this.props);
        var tooltipRelativeToBody = props.tooltipRelativeToBody === undefined ? true : props.tooltipRelativeToBody;
        var isCheckedClass = props.value === true ? 'checked' : '';
        var isDisabledClass = props.disabled ? 'disabled' : '';
        var isLargeClass = props.large ? 'large' : '';
        var userClass = props.className ? props.className : '';
        var classNames = namespacedClassnames(checkboxKey, isCheckedClass, isDisabledClass, isLargeClass, (_a = {}, _a[userClass] = !!props.className, _a));
        var checkIcon = (React.createElement("span", { className: 'check-icon' },
            React.createElement(Icon, { icon: props.large ? checkboxLargeIconSvgData : checkboxIconSvgData })));
        var comp = (React.createElement("label", { className: classNames },
            checkIcon,
            React.createElement("input", { type: 'checkbox', checked: props.value, style: { display: 'none' }, onClick: this.toggle }),
            React.createElement(Text, { type: 'hxs', color: props.disabled ? 't50' : 't20', className: 'checkbox-body' }, props.children)));
        return props.disabled && typeof props.disabled !== 'boolean' ? (React.createElement(Tooltip, { className: 'checkbox-disabled-tooltip', direction: props.tooltipDirection, relativeToBody: tooltipRelativeToBody, body: props.disabled, align: props.tooltipTextAlign }, comp)) : comp;
    };
    return Checkbox;
}(React.PureComponent));
export { Checkbox };
//# sourceMappingURL=checkbox.js.map